export type AfipServiceParams = {
  certificateKey: string;
  certificate: string;
  cuit: number;
};

export type GenerateKeyAndCsrParams = {
  cuit: string;
  companyName: string;
  commonName: string;
};

export async function generateKeyAndCsr(apiBaseUrl: string, params: GenerateKeyAndCsrParams) {
  const generateKeyAndCsrUrl = `${apiBaseUrl}/arca/certificados/generate`;

  const data = await fetch(generateKeyAndCsrUrl, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => <{ keyBase64: string; csrBase64: string }>data);

  return {
    key: atob(data.keyBase64),
    csr: atob(data.csrBase64),
  };
}

export async function getPointOfSales(apiBaseUrl: string, params: AfipServiceParams) {
  const getPointOfSalesUrl = `${apiBaseUrl}/arca/point-of-sales`;

  const data = await fetch(getPointOfSalesUrl, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(response => response.json())
    .then(data => <{ pointOfSales: any[] }>data);

  return data.pointOfSales;
}

export async function getParameters(apiBaseUrl: string, params: AfipServiceParams) {
  const getParametersUrl = `${apiBaseUrl}/arca/parameters`;

  const data = await fetch(getParametersUrl, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => response.json());

  return data;
}

export async function generateVoucher(
  apiBaseUrl: string,
  params: { establishmentId: string; orderId: string },
) {
  const generateVoucherUrl = `${apiBaseUrl}/arca/generate-voucher`;

  return await fetch(generateVoucherUrl, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(async response => {
    const data = await response.json();

    if (response.ok) {
      return <{ taxVoucher: any }>data;
    } else {
      return Promise.reject(data);
    }
  });
}
